





















































































































































































/// <reference types="@types/googlemaps" />
import { Component, Prop, Vue } from "vue-property-decorator";
import { Gender, RiskLevelForScore, RiskTextForScore } from "@/model/Model";
import {
  Borough,
  Clinic,
  GetBoroughByName,
  SimpleLatLng as LatLng,
  SimpleLatLng
} from "@/model/Boroughs";
import Link from "../components/Link.vue";
// tslint:disable-line
import iconHome from "../assets/icons/Your-home-symbol.svg";
// tslint:disable-line
import iconClinic from "../assets/icons/Service-symbol.svg";
import ServiceInformation from "@/components/ServiceInformation.vue";
import { LogEvent, removeWidows } from "@/utils";
import { GrayscaleMapConfig } from "@/model/GrayscaleMapConfig";
import { RiskLevel } from "@/model/RiskLevel";
import { UserInteractionEvent } from "@/model/UserEvents";

const GOOGLE_MAPS_URL =
    "//maps.googleapis.com/maps/api/js?key=AIzaSyAm9qFQ80-5TOJqZSR70Nr9qSgyt2CPXxo";

interface RegionRequest {
  success: boolean;
  region: string;
}

enum LookupError {
  POSTCODE_NOT_FOUND,
  GEOCODER_FAILED,
  NON_COMMISSIONED_POSTCODE,
  HARD_CONNECTION_ERROR
}

@Component({
  components: {
    Link,
    ServiceInformation
  }
})
export default class FindSupport extends Vue {
  public static navButtonClasses: string[] = ["find-support"];
  public static navButtonLabel: () => string = () => "Find support near you";

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public isMobile!: boolean;

  private postcode: string = "";
  private submittingPostcode: boolean = false;

  // True for testing
  private submittedPostcode: boolean = false;
  private loadedGoogleMaps: boolean = false;
  private map: google.maps.Map | null = null;
  private homeLocation: { lat: number; lng: number } | undefined;
  private selectedMarkerPos: { lat: number; lng: number } | null = null;
  private error: string | undefined;

  // NOTE(jon): Islington times needs work
  private mapRegion: string | undefined;
  private openInfo: google.maps.InfoWindow | undefined;

  private get isIncreasingRisk(): boolean {
    return RiskLevelForScore(this.score) === RiskLevel.Increasing;
  }

  private mounted() {
    if (!document.querySelector(`script[src="${GOOGLE_MAPS_URL}"]`)) {
      this.loadedGoogleMaps = true;
      const googleMaps = document.createElement("script") as HTMLScriptElement;
      googleMaps.async = true;
      googleMaps.defer = true;
      googleMaps.onload = this.onMapLoaded.bind(this);
      googleMaps.setAttribute("src", GOOGLE_MAPS_URL);
      (document.head as HTMLHeadElement).appendChild(googleMaps);
    } else {
      // TODO(jon): Should we retain the postcode/region entered in the global store, so we
      // can return here on navigating?
      if (document.getElementById("map")) {
        this.onMapLoaded();
      }
    }
  }

  private onMapLoaded() {
    if (this.mapRegion !== undefined) {
      const borough = GetBoroughByName(this.mapRegion as string);
      const mapElement = document.getElementById("map") as HTMLDivElement;
      this.map = new google.maps.Map(mapElement, {
        zoom: borough.zoomLevel || 13,
        center: this.homeLocation,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: { mapTypeIds: [] },
        disableDefaultUI: true,
        zoomControl: true,
        styles: GrayscaleMapConfig as google.maps.MapTypeStyle[]
      });
      const homeLoc = this.homeLocation as LatLng;
      const pos = new google.maps.LatLng(homeLoc.lat, homeLoc.lng);

      const homeIcon = {
        url: iconHome,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0)
      };
      const clinicIcon = {
        url: iconClinic,
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0)
      };
      const homeMarker = this.markerAtPosition(
          pos,
          null,
          "You are here",
          homeIcon
      );
      google.maps.event.addListener(homeMarker, "click", () => {
        this.selectedMarkerPos = null;
      });
      const clinics = this.clinics.filter(
          ({ clinic }) => clinic.location !== undefined
      );
      const clinicMarkers = [];
      for (const { clinic, index: clinicIndex } of clinics) {
        const clinicLoc = clinic.location as SimpleLatLng;
        const clinicLocation = new google.maps.LatLng(
            clinicLoc.lat,
            clinicLoc.lng
        );
        clinicMarkers.push({
          marker: this.markerAtPosition(
              clinicLocation,
              clinicIndex,
              clinic.name,
              clinicIcon
          ),
          clinicIndex
        });
      }
      const closestClinic = this.closestClinics.filter(
          ({ clinic }) => clinic.location !== undefined
      )[0];
      if (closestClinic) {
        const info = new google.maps.InfoWindow({
          content: (document.getElementById(
              `clinic-${closestClinic.index}`
          ) as HTMLDivElement).innerHTML
        });
        const marker = clinicMarkers.find(
            ({ clinicIndex }) => clinicIndex === closestClinic.index
        ) as {
          marker: google.maps.Marker;
          clinicIndex: number;
        };
        // this.selectedMarkerPos = clinics[marker.clinicIndex].clinic.location as SimpleLatLng;
        info.open(this.map as google.maps.Map, marker.marker);
        this.openInfo = info;
      }
    }
  }

  private markerAtPosition(
      pos: google.maps.LatLng,
      clinicIndex: number | null,
      title: string,
      icon: google.maps.Icon
  ): google.maps.Marker {
    const marker: google.maps.Marker = new google.maps.Marker();
    marker.setMap(this.map as google.maps.Map);
    marker.setPosition(pos);
    marker.setTitle(title);
    marker.setClickable(true);
    marker.setIcon(icon);
    if (clinicIndex !== null) {
      google.maps.event.addListener(marker, "click", () => {
        if (this.openInfo) {
          this.openInfo.close();
        }
        const info = new google.maps.InfoWindow({
          content: (document.getElementById(
              `clinic-${clinicIndex}`
          ) as HTMLDivElement).innerHTML
        });
        info.open(this.map as google.maps.Map, marker);
        const p = marker.getPosition();
        if (p) {
          this.selectedMarkerPos = { lat: p.lat(), lng: p.lng() };
        }
        this.openInfo = info;
      });
    }
    return marker;
  }

  private clinicIsSelected(clinic: Clinic): boolean {
    const clinicLoc = clinic.location as SimpleLatLng;
    if (!clinicLoc) {
      return false;
    }
    return (
        this.selectedMarkerPos !== null &&
        clinicLoc.lat === this.selectedMarkerPos.lat &&
        clinicLoc.lng === this.selectedMarkerPos.lng
    );
  }

  private get riskType(): string {
    return RiskTextForScore(this.score);
  }

  private get postcodeInputIsValid(): boolean {
    return this.postcode.length >= 5;
  }

  private geocode(postcode: string): Promise<LatLng | LookupError> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode(
          {
            address: postcode,
            region: "uk"
          },
          (results, status) => {
            if (((status as unknown) as string) === "OK" && results.length) {
              resolve(results[0].geometry.location.toJSON() as LatLng);
            } else {
              resolve(LookupError.GEOCODER_FAILED);
            }
          }
      );
    });
  }

  private getRegion(postcode: string): Promise<RegionRequest> {
    const isLocal = window.location.href.indexOf("localhost") !== -1;
    const isStaging =
        window.location.href.indexOf("staging.drinkcoach.org.uk") !== -1;
    const isProd =
        window.location.href.indexOf("audit.drinkcoach.org.uk") !== -1;
    let apiRoot = "";
    if (isStaging || isLocal) {
      apiRoot = "https://staging.drinkcoach.org.uk";
    } else if (isProd) {
      apiRoot = "https://audit.drinkcoach.org.uk";
    }
    return new Promise((resolve, reject) => {
      fetch(`${apiRoot}/api/check-postcode.php`, {
        method: "POST",
        body: `postcode=${postcode}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
          .then(response => {
            response
                .text()
                .then(text => {
                  try {
                    const textJSON = JSON.parse(text) as RegionRequest;
                    if (textJSON.success) {
                      LogEvent(UserInteractionEvent.DirectedToHub);
                      resolve(textJSON);
                    } else {
                      if (this.region.name === "Leeds") {
                        LogEvent(UserInteractionEvent.DirectedToHub);
                        // Work out which hub for Leeds the postcode corresponds to:
                        resolve({ success: true, region: "Leeds" });
                      } else {
                        reject(LookupError.NON_COMMISSIONED_POSTCODE);
                      }
                    }
                  } catch (e) {
                    // Actually the json failed to parse, but this should "Never Happen"TM
                    reject(LookupError.POSTCODE_NOT_FOUND);
                  }
                })
                .catch(() => {
                  reject(LookupError.HARD_CONNECTION_ERROR);
                });
          })
          .catch(() => {
            reject(LookupError.HARD_CONNECTION_ERROR);
          });
    });
  }

  private formatAddress(address: string): string {
    return removeWidows(address, 3);
  }

  private get anyClinicsHaveLocations(): boolean {
    return (
        this.clinics.find(({ clinic }: { clinic: Clinic }) => clinic.hasOwnProperty("location")) !==
        undefined
    );
  }

  private postcodeMatchesLeedsSuffix(clinic: Clinic): boolean {
    if (clinic.postcodeSuffixes !== undefined) {
      for (const suffix of clinic.postcodeSuffixes) {
        const postcode = this.postcode
            .toUpperCase()
            .replace(/ /g, "");
        let postcodeSuffix;
        if (postcode.length === 7) {
          // Take the first four
          postcodeSuffix = postcode.substr(0, 4);
        } else if (postcode.length === 6) {
          // Take the first three
          postcodeSuffix = postcode.substr(0, 3);
        }
        if (postcodeSuffix === suffix) {
          return true;
        }
      }
    }
    return false;
  }

  private get clinics(): Array<{ index: number; clinic: Clinic }> {
    if (this.region.name === "Lewisham") {
      this.mapRegion = "Lewisham";
      this.homeLocation = { lat: 0, lng: 0 };
    }
    if (this.region.name === "Waltham Forest") {
      this.mapRegion = "Waltham Forest";
      this.homeLocation = { lat: 0, lng: 0 };
    }
    if (this.mapRegion !== undefined) {
      const borough = GetBoroughByName(this.mapRegion as string);
      if (borough.clinics !== undefined) {
        if (borough.name === "Leeds") {
          return borough.clinics
              .filter(clinic => {
                if (
                    clinic.alwaysShowInResults &&
                    borough.clinics!.some(c => this.postcodeMatchesLeedsSuffix(c))
                ) {
                  return true;
                } else if (this.postcodeMatchesLeedsSuffix(clinic)) {
                  return true;
                }
                return false;
              })
              .map((clinic, index) => ({ clinic, index })) as Array<{
            index: number;
            clinic: Clinic;
          }>;
        }
        const clinics = borough.clinics!.filter(clinic => {
          return (
              (clinic.showAtRiskLevel === undefined ||
              clinic.showAtRiskLevel!.includes(
                  RiskLevelForScore(this.score)
              ))
          );
        });

        return clinics
            .filter(
                clinic =>
                    clinic.alwaysShowInResults ||
                    (clinic.address !== undefined && clinic.location !== undefined)
            )
            .map((clinic, index) => ({ clinic, index })) as Array<{
          index: number;
          clinic: Clinic;
        }>;
      }
    }
    return [];
  }

  private get closestClinics(): Array<{ index: number; clinic: Clinic }> {
    let numClosest = 5;
    const c = this.clinics;
    const clinics = c.filter(({ clinic }) => clinic.location !== undefined);
    const forced = c
        .filter(
            ({ clinic }: { clinic: Clinic }) =>
                clinic.location === undefined && clinic.alwaysShowInResults
        )
        .map(({ clinic, index }) => ({ clinic, index, d: 0 }));
    // console.log(clinics, forced);
    const clinicDistancesFromUser = [];
    let userPosition;
    if (this.selectedMarkerPos !== null) {
      userPosition = this.selectedMarkerPos;
    } else {
      userPosition = this.homeLocation as SimpleLatLng;
    }
    const R = 6371e3;
    // Using 'spherical law of cosines' from https://www.movable-type.co.uk/scripts/latlong.html
    const lat1 = (userPosition.lat * Math.PI) / 180;
    const costLat1 = Math.cos(lat1);
    const sinLat1 = Math.sin(lat1);
    for (const { clinic, index } of clinics) {
      const clinicPosition = clinic.location as SimpleLatLng;
      let distanceToClinic = 0;
      if (
          clinicPosition.lat !== userPosition.lat ||
          clinicPosition.lng !== userPosition.lng
      ) {
        const lat2 = (clinicPosition.lat * Math.PI) / 180;
        const deltaLng =
            ((clinicPosition.lng - userPosition.lng) * Math.PI) / 180;
        const part1 = Math.acos(
            sinLat1 * Math.sin(lat2) +
            costLat1 * Math.cos(lat2) * Math.cos(deltaLng)
        );
        distanceToClinic = part1 * R;
      }

      if (clinic.alwaysShowInResults) {
        numClosest++;
        clinicDistancesFromUser.push({
          d: 0,
          clinic,
          index
        });
      } else {
        clinicDistancesFromUser.push({
          d: distanceToClinic,
          clinic,
          index
        });
      }
    }
    const sortedDistances = clinicDistancesFromUser.sort((a, b) =>
        a.d === b.d ? 0 : a.d < b.d ? -1 : 1
    );
    const finalSortedDistances = sortedDistances
        .slice(0, Math.min(numClosest, sortedDistances.length))
        .map(({ clinic, index }) => ({ clinic, index }));
    const forcedClinics = forced.map(({ clinic, index }) => ({
      clinic,
      index
    }));

    const finalOrder = finalSortedDistances.concat(forcedClinics);
    // See if there is any that needs to be put to the front:
    const forcedFirst = finalOrder.findIndex(
        ({ clinic }: { clinic: Clinic }) =>
            (clinic as Clinic).alwaysShowFirst === true
    );
    if (forcedFirst !== -1) {
      // Swap with the front element.
      const first = finalOrder.splice(forcedFirst, 1)[0];
      finalOrder.unshift(first);
    }
    return finalOrder;
  }

  private async submitPostcode(event: Event) {
    event.preventDefault();
    let timedOut = false;
    // Add spinner
    this.submittingPostcode = true;

    LogEvent(UserInteractionEvent.PostCodeEntered);

    const timeout = setTimeout(() => {
      this.submittingPostcode = false;
      this.submittedPostcode = true;
      timedOut = true;
    }, 7000);

    // Check postcode in DB, and if present, geocode so we can
    // show it on the map.
    Promise.all([
      this.geocode(this.postcode),
      this.getRegion(this.postcode)
    ] as Array<Promise<(LatLng | LookupError) | string>>)
        .then(([location, regionReq]) => {
          if (!timedOut) {

            clearTimeout(timeout);
            this.mapRegion = ((regionReq as unknown) as RegionRequest).region;
            if (typeof location === "object") {
              this.homeLocation = location as LatLng;
            } else {
              // We have a soft failure of not finding lat lng on map.
              // homeLocation becomes the first clinic in the list.
              this.homeLocation = { lat: 0, lng: 0 };
            }
            this.submittingPostcode = false;
            this.submittedPostcode = true;
            this.$nextTick(() => {
              if (document.getElementById("map")) {
                this.onMapLoaded();
              }
            });
          }
        })
        .catch((reason: LookupError) => {
          // If geocoder failed to find postcode, but we got a matching region, we can show
          // the clinics for that region, just without a homeLocation.
          if (!timedOut) {
            clearTimeout(timeout);
            switch (reason) {
              case LookupError.GEOCODER_FAILED:
                // Should never happen, since this is a soft failure mode that goes through
                // resolve rather than reject in the Promise.
              case LookupError.HARD_CONNECTION_ERROR:
                this.error = "Lookup failed, please try again later";
                this.submittingPostcode = false;
                // TODO(jon): Backend should trigger email to me?
                break;
              case LookupError.NON_COMMISSIONED_POSTCODE:
              case LookupError.POSTCODE_NOT_FOUND:
                this.submittedPostcode = true;
                this.submittingPostcode = false;
                break;
            }
          }
        });
  }
}
